import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClockFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M12 2c5.53 0 10 4.48 10 10 0 5.53-4.47 10-10 10-5.52 0-10-4.47-10-10C2 6.48 6.48 2 12 2m-.35 4.93c-.41 0-.75.33-.75.75v5.05c0 .26.14.5.37.64l3.92 2.34a.742.742 0 0 0 1.03-.26c.21-.35.1-.81-.26-1.03L12.4 12.3V7.68c0-.42-.34-.75-.75-.75"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClockFilled);
export default ForwardRef;
